import Seo from '../utils/Seo'; 
import CharacterCards from './CharacterCards';
import '../css/patzcuaro.css';
import '../css/characterCards.css';

export default function Personajes() {

  return (
    <div className='patzcuaro-bg mainMargin-close'>
        <Seo
          title="Los personajes de Noche de Muertos Día de la Vida"
          description="Descubre la aventura de Valentina en el Día de Muertos."
        />
        <CharacterCards />
        <div className="hogar"></div>
        <div className="tiles tiles_left"></div>
        <div className="tiles tiles_right"></div>
    </div>
  );
}